import React, { Component } from 'react';
import { SofaItemImage, SofaItemOverview, SofaQuantity } from '@sofology/sofologycomponents';

import './ReadonlyItem.scss';

import { BasketItemModel, ProductTypes } from 'models/Basket';
import { formatCurrency } from 'formatters';
import { BasketSofaglide, BasketSofashield } from 'components';

interface OwnProps {
    checkoutItem: BasketItemModel;
}

//  Any changes made here should be synced to BasketItemBundle.tsx / BasketItem.tsx / ReadonlyItemBundle.tsx
class ReadonlyItem extends Component<OwnProps> {
    render(): JSX.Element {
        const { checkoutItem } = this.props;
        const isDonated = checkoutItem.product.type === ProductTypes.Donation;
        const isSofashield = checkoutItem.product.type === ProductTypes.Sofashield;
        const isSofaRescue = checkoutItem.product.type === ProductTypes.SofaRescue;

        const shouldRenderSofaQuantity = !isDonated && !isSofashield && !isSofaRescue;

        return (
            <div className='readonly-item'>
                <div className='readonly-item__content'>
                    <SofaItemImage product={checkoutItem.product} enableSofaLink={false} variant='small' />
                    <div className='readonly-item__content__details'>
                        <SofaItemOverview product={checkoutItem.product} enableSofaLink={false} variant='small' />
                        <div className='readonly-item__content__controls'>
                            {checkoutItem.hasDiscount()
                                ? this.renderDiscountedPrice()
                                : this.renderPrice()
                            }
                            {
                                shouldRenderSofaQuantity && <SofaQuantity
                                    value={checkoutItem.quantity}
                                    disabled={true}
                                    hideControls={true} />
                            }
                        </div>
                    </div>
                </div>
                {
                    checkoutItem.sofashieldQuantity > 0
                    && <BasketSofashield
                        linkedSku={checkoutItem.product.code}
                        range={checkoutItem.range?.toLowerCase() ?? ''}
                        optionsQuantity={checkoutItem.quantity}
                        sofashieldQuantity={checkoutItem.sofashieldQuantity}
                        loading={false} />
                }

                {
                    checkoutItem.linkedSofaglide &&
                    <BasketSofaglide
                        priceValue={checkoutItem.linkedSofaglide.price.value * checkoutItem.linkedSofaglide.quantity}
                        range={checkoutItem.range?.toLowerCase() ?? ''}
                        sofaglideParentCode={checkoutItem.linkedSofaglide.baseProductCode}
                        loading={false}
                    />
                }
            </div>
        );
    }

    renderPrice(): JSX.Element {
        const { checkoutItem } = this.props;

        return (
            <span className='readonly-item__content__controls__price'>
                {checkoutItem.totalPrice.value !== 0
                    ? formatCurrency(checkoutItem.totalPrice.value, 0)
                    : <span className='readonly-item__content__controls__price-free'>FREE</span>
                }
            </span>
        );
    }

    renderDiscountedPrice(): JSX.Element {
        const { checkoutItem } = this.props;

        return (
            <div className='readonly-item__content__controls__discount'>
                <div className='readonly-item__content__controls__discount-now'>
                    {formatCurrency(checkoutItem.totalPrice.value, 0)}
                </div>
                <div className='readonly-item__content__controls__discount-was'>
                    was <span>{formatCurrency(checkoutItem.totalPrice.value + checkoutItem.savingsPrice.value, 0)}</span>
                </div>
                <div className='readonly-item__content__controls__discount-save'>
                    save {formatCurrency(checkoutItem.savingsPrice.value, 0)}
                </div>
            </div>
        );
    }
}

export default ReadonlyItem;